import React from 'react';
import { FormattedMessage } from 'react-intl';

import { boardsReadOnlyMode } from '../../config';
import m from './messages';

// eslint-disable-next-line max-len
const IMAGE_DESKTOP = 'https://cmsasset.ancestrycdn.com/test/content/dam/onsite/us/2026/Community/us-2026-community-banner-d.png/jcr:content/renditions/cq5dam.web.1280.1280.png';
// eslint-disable-next-line max-len
const IMAGE_TABLET = 'https://cmsasset.ancestrycdn.com/test/content/dam/onsite/us/2026/Community/us-2026-community-banner-t.png/jcr:content/renditions/cq5dam.web.1280.1280.png';
// eslint-disable-next-line max-len
const IMAGE_MOBILE = 'https://cmsasset.ancestrycdn.com/test/content/dam/onsite/us/2026/Community/us-2026-community-banner-m.png/jcr:content/renditions/cq5dam.web.1280.1280.png';

export default function ArchivedBanner() {
  if (!boardsReadOnlyMode) return null;

  return (
    <div className="archived-banner">
      <div className="page archived-banner__content">
        <picture className="archived-banner__picture">
          <source media="(max-width: 767px)" srcSet={IMAGE_MOBILE} />
          <source media="(min-width: 768px) and (max-width: 1024px)" srcSet={IMAGE_TABLET} />
          <source media="(min-width: 1025px)" srcSet={IMAGE_DESKTOP} />
          <img
            className="archived-banner__image"
            src={IMAGE_DESKTOP}
            alt=""
            aria-hidden="true"
          />
        </picture>
        <div className="archived-banner__text">
          <h2 className="archived-banner__title">
            <FormattedMessage {...m.title} />
          </h2>
          <p className="archived-banner__subtitle">
            <FormattedMessage {...m.subtitle} />
          </p>
        </div>
      </div>
    </div>
  );
}
